module.exports = __webpack_public_path__ + "img/food.dd73afa1.png";